import solutionPartner from '@/views/SSO/SSOConfig/solutionPartner';
import solutionPartnerV2 from '@/views/SSO/SSOConfig/solutionPartnerV2';
import lms from '@/views/SSO/SSOConfig/lms';
import tex from '@/views/SSO/SSOConfig/tex';
import liveChat from '@/views/SSO/SSOConfig/liveChat';
import loginWithToken from '@/views/SSO/SSOConfig/loginWithToken';

export default [
  {
    path: 'sso/solution-partner',
    name: 'SSO/SolutionPartner',
    meta: { requiresAuth: true },
    props: {
      ssoObject: solutionPartner,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
  {
    path: 'sso/solution-partners',
    name: 'SSO/SolutionPartners',
    meta: { requiresAuth: true },
    props: {
      ssoObject: solutionPartnerV2,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
  {
    path: 'sso/lms',
    name: 'SSO/LMS',
    meta: { requiresAuth: true },
    props: {
      ssoObject: lms,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
  {
    path: 'sso/tex',
    name: 'SSO/TEX',
    meta: { requiresAuth: true },
    props: {
      ssoObject: tex,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
  {
    path: 'sso/live-chat',
    name: 'SSO/LiveChat',
    meta: { requiresAuth: true },
    props: {
      ssoObject: liveChat,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
  {
    path: 'sso/login',
    name: 'SSO/Login',
    meta: { requiresAuth: true },
    component: () => import('@/views/SSO/Login.vue'),
  },
  {
    path: 'sso/login-with-token',
    name: 'SSO/LoginWithToken',
    meta: { requiresAuth: false },
    props: {
      ssoObject: loginWithToken,
    },
    component: () => import('@/views/SSO/SSOBase.vue'),
  },
];
